import { string } from 'prop-types'

export default {
  title: string,
  type: string,
  runtime: string,
  cut: string,
  distributor: string,
  date: string,
  rating: string
}
